<template>
  <div class="api-lookup-auth-section h-100">
    <Loading
      :active.sync="isLoading"
      :is-full-page="false"
      :color="loaderColor"
      loader="dots"
      :background-color="loaderBackgroundColor"
    />
    <div class="section-content">
      <div
        v-for="(param, index) in formFields.parameters"
        :key="index"
        class="row"
      >
        <div class="input-container">
          <VasionInput
            :id="`paramkey-${index}`"
            v-model="param.ParamKey"
            title="Key"
            inputType="top-white"
            placeholder="Key"
            :required="true"
            @input="emitWrapperIsDirty"
          />
          <VasionInput
            :id="`paramvalue-${index}`"
            ref="test"
            v-model="param.ParamValue"
            data-paste-target="true"
            title="Value"
            inputType="top-white"
            placeholder="Value"
            :required="true"
            @input="emitWrapperIsDirty"
          />
        </div>
        <div title="Encrypt" class="vasion-input-label-top">
          <VasionTooltip :text="tooltipEncryptMessage" position="top">
            Encrypt
          </VasionTooltip>
          <VasionCheckbox
            id="paramencrypt"
            :checked="param.isEncrypted"
            @change="isEncryptedChanged(param)"
          />
        </div>
        <VasionButton
          @vasionButtonClicked="deleteRow(index)"
          icon="VasionDeleteIcon"
        />
      </div>
      <VasionButton
        class="ml-0"
        classProp="secondary"
        @vasionButtonClicked="addRow"
      >
        New Key Value Pair
      </VasionButton>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'

export default {
  name: 'ApiLookupParamsFormSection',
  components: {
    Loading,
  },
  props: {
    parameters: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formFields: {
        parameters: [],
      },
      formReadyToBeSaved: false,
      isDirty: false,
      isLoading: false,
      loaderBackgroundColor: loaderBackgroundColor,
      loaderColor: loaderColor,
      tooltipEncryptMessage:
        'Data within Vasion’s database will be encrypted while sent data will be decrypted',
    }
  },
  computed: {},
  async created() {
    this.formFields.parameters = this.parameters || []
  },
  methods: {
    addRow() {
      this.formFields.parameters.push({
        ParamKey: '',
        ParamValue: '',
        isEncrypted: false,
      })
      this.emitWrapperIsDirty()
    },
    deleteRow(index) {
      this.formFields.parameters.splice(index, 1)
      this.emitWrapperIsDirty()
    },
    emitWrapperIsDirty() {
      const payload = {
        section: 'params',
        data: {
          Parameters: this.formFields.parameters || [],
        },
      }
      this.$emit('markAsDirty', payload)
    },
    isEncryptedChanged(param) {
      param.isEncrypted = !param.isEncrypted
      if (!param.isEncrypted) {
        param.ParamValue = ''
      }
      this.emitWrapperIsDirty()
    },
    setReactiveValue(param, value) {
      const indexStr = param.match(/-(\d+)$/)
      const index = parseInt(indexStr[1])
      this.formFields.parameters[index].ParamValue = value
      this.emitWrapperIsDirty()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
@import '@/assets/css/light-theme-system-palette.scss';

::v-deep .ml-0 button {
  margin-left: 0;
}

.section-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

::v-deep .row .vasion-input {
  margin-left: 10px;
  width: 100%;
}

.input-container {
  display: flex;
  flex: 1;
  gap: 10px;
}

.row .vasion-button {
  background: none;
  border: none;
  cursor: pointer;
  margin-top: 20px;
}

.row .vasion-input-label-top {
  margin-top: -40px;
  margin-left: 10px;
}

.row .vasion-checkbox {
  margin-left: 10px;
  margin-top: 10px;
}
</style>
